import React from 'react';
import {connect} from 'react-redux';

import TabLinkGroup from '../common/TabLinkGroup';
import TabLink from '../common/TabLink';
import Paper from '../common/Paper';
import {Navigation} from "../Location/LocationCard.styled";
import {compose} from "redux";


const StationTabs = props => {
    const {
        stationId,
        isAdministrator,
    } = props;

    return (
        <Paper padding="0">
            <Navigation>
                {isAdministrator
                    ? <TabLinkGroup>
                        <TabLink to={`/charge-points/${stationId}/information`}>Информация</TabLink>
                        <TabLink to={`/charge-points/${stationId}/controllers`}>Коннекторы</TabLink>
                        <TabLink to={`/charge-points/${stationId}/console`}>Консоль</TabLink>
                        <TabLink to={`/charge-points/${stationId}/logs`}>Логи</TabLink>
                        <TabLink to={`/charge-points/${stationId}/description`}>Описание</TabLink>
                    </TabLinkGroup>
                    : <TabLinkGroup>
                        <TabLink to={`/charge-points/${stationId}/information`}>Информация</TabLink>
                        <TabLink to={`/charge-points/${stationId}/controllers`}>Коннекторы</TabLink>
                    </TabLinkGroup>
                }
            </Navigation>
        </Paper>
    );
};

const mapStateToProps = ({manager}, {match}) => ({
    isAdministrator: manager.data?.role === 'administrator',
});

export default compose(
    connect(mapStateToProps),
)(StationTabs);
